import { useTranslation } from 'react-i18next';

import { PlotType } from '@/api/rest/resources/types/plot';
import { Logger } from '@/lib/logs/logger';

import { ExcelState } from '../types';
import { extractServerError, NONE_COLUMN, UNKNOWN_ERROR_KEY } from '../utils';
import { useCreateDraftPlotsFromSpreadsheet } from './useDraftPlotUploadActions';

type ExcelSubmitCallbacks = {
  organizationId: string | null;
  onSuccess: (taskId: string) => void;
  onError: (message: string) => void;
};

export const useExcelPlotSubmit = ({ organizationId, onSuccess, onError }: ExcelSubmitCallbacks) => {
  const { t } = useTranslation();
  const { submit: submitSpreadsheet, isSubmitting } = useCreateDraftPlotsFromSpreadsheet();

  const submit = async (excelState: ExcelState) => {
    try {
      const response = await submitSpreadsheet({
        file_id: excelState.fileId,
        sheet_name: excelState.selectedSheet || undefined,
        latitude_label: excelState.latColumn,
        longitude_label: excelState.lngColumn,
        area_label: excelState.areaColumn !== NONE_COLUMN ? excelState.areaColumn : undefined,
        area_units: excelState.areaUnits,
        name_label: excelState.nameColumn !== NONE_COLUMN ? excelState.nameColumn : undefined,
        land_type: excelState.landType as PlotType,
        organization: organizationId ?? undefined,
      });
      onSuccess(response.task_id);
    } catch (error) {
      onError(extractServerError(error, t(UNKNOWN_ERROR_KEY)));
      Logger.errorOnce(error as Error);
    }
  };

  return { submit, isSubmitting };
};
